import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import QuestionBlueIcon from '../../icons/QuestionBlueIcon.jsx';

const CurrentCSVDownloadButton = ({ onDownloadCsv }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);

  const handleShow = () => setShowModal(true);

  const renderModal = () => (
    <Modal bsSize="sm" show={showModal} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>To edit attached Group(s) and Employee(s):</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ol
          className="text-muted"
          style={{ marginBottom: '12px', paddingLeft: '16px' }}
        >
          <li>Download Participants list.</li>
          <li>Edit it and save to your PC.</li>
          <li>Upload edited or new file:</li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button block bsStyle="primary" onClick={onDownloadCsv} target="_blank">
          Download Participant CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <React.Fragment>
      <button
        aria-label="View help"
        type="button"
        className="btn-clear flex flex-align-center p-0 text-muted"
        onClick={handleShow}
      >
        Need a Current Participants CSV? Click the question mark to download
        &nbsp;
        <QuestionBlueIcon />
      </button>
      {renderModal()}
    </React.Fragment>
  );
};

export default CurrentCSVDownloadButton;
